import { useEffect } from 'react';
import { usePaginationState } from '../../../../../infra/ui/table/use-pagination-state';
export var usePagination = function (tableFilters) {
    var tablePagination = usePaginationState({ pageSize: 10 });
    useEffect(function () {
        tablePagination.setPageIndex(0);
    }, [tableFilters.statusFilter, tableFilters.searchFilter]);
    return tablePagination;
};
